import { connect } from 'react-redux'
import { selectIsInboxBootstrapped } from 'ducks/bootstrap/selectors/selectIsInboxBootstrapped'
import { selectCurrentSearchIsError } from 'ducks/searches/selectors'

import { selectAgentHasMailboxAccess } from 'ducks/mailboxes/selectors/selectAgentHasMailboxAccess'
import { doHideLaunchBar } from 'actions/app'
import { selectShowInboxesEmptyPage } from 'selectors/trial_setup'
import { selectIsBootstrapped } from 'ducks/bootstrap/selectors/selectIsBootstrapped'
import {
  selectFlag,
  selectShouldHideFeaturesAnnoucement,
} from 'ducks/flags/selectors'
import { HIDE_HELPLY_PRODUCT_HUNT_BANNER } from 'ducks/flags/flagNames'
import { selectIsKbMigrationBannerShowing } from 'subapps/kb/selectors/knowledge_bases'
import Layout from './view'

const select = state => {
  return {
    hasMailboxAccess: selectAgentHasMailboxAccess(state),
    hasSearchErrored: selectCurrentSearchIsError(state),
    showEmptyInboxPage: selectShowInboxesEmptyPage(state),
    isInboxBootstrapped: selectIsInboxBootstrapped(state),
    isBootstrapped: selectIsBootstrapped(state),
    shouldHideAnnouncement:
      selectShouldHideFeaturesAnnoucement(state) ||
      (selectFlag(state)(HIDE_HELPLY_PRODUCT_HUNT_BANNER) !== true &&
        !selectIsKbMigrationBannerShowing(state)),
  }
}

const perform = {
  doHideLaunchBar,
}

export default connect(select, perform)(Layout)
